/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { useEffect } from 'react'
import { cssParser } from '../utils/parser'

const Tutorial = ({ css, onComplete }) => {

    useEffect(() => {
        if (document.getElementById("tutorial-welcome").style.color === "white") {
            onComplete();
        }
    }, [css])

    return (
        <div style={{ "height": "100%", "width": "100%", backgroundColor: "black", display: "flex", flexDirection: "column" }}>
            #text-container
            <h1 id="tutorial-welcome" style={cssParser(css)}>Welcome to Frontend Warrior</h1>
        </div>
    )
}

export default Tutorial